/* @flow */

import * as React from 'react';
import { inject, observer } from 'mobx-react';

import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';

import ActionDrawerBlock from 'views/ActionDrawer/components/ActionDrawerBlock/ActionDrawerBlock';
import ActionDrawerTable from 'views/ActionDrawer/components/ActionDrawerTable/ActionDrawerTable';
import ActionDrawerFormButtons from 'views/ActionDrawer/components/ActionDrawerFormButtons/ActionDrawerFormButtons';
import type TypeActionDrawerStore from 'stores/ActionDrawerStore.js';

import type Form from 'forms/_.extend';
import ElectroSelectWithOther from 'forms/components/inputs/ElectroSelectWithOther/ElectroSelectWithOther';
import ElectroMessageBarCont from 'forms/components/inputs/ElectroMessageBarCont/ElectroMessageBarCont';

import type { TypeDisplayErrors } from 'forms/validation/Validator';

import styles from '../../../../ActionDrawer.module.scss';
import { formulateUri } from 'tables/components/ReportView/state';

type TypeProps = {
  currentAccountDetails: Object,
  form: Form,
  actionDrawerStore: TypeActionDrawerStore,
} & TranslatorProps;

@translate()
@inject('actionDrawerStore')
@observer
export default class ArchiveAccountForm extends React.Component<*> {
  render(): React.Node {
    const { t }: TranslatorProps = this.props;
    const { actionDrawerStore }: TypeProps = this.props;
    const currentAccountDetails: Object = this.props.currentAccountDetails;
    const form: Form = this.props.form;

    const accountDetails: Array<Array> = [
      [t('general:trading_account'), currentAccountDetails.name],
      [t('general:trading_accounts.labels.number'), currentAccountDetails.account_no],
    ];

    return (
      <React.Fragment>
        <div className={styles['action-drawer-content']}>
          <ActionDrawerBlock
            divider={true}
            gutters={true}
            heading={t('general:trading_accounts.labels.details')}
          >
            <ActionDrawerTable data={accountDetails} />
            {currentAccountDetails.contracts_count !== 0 && (
              <ElectroMessageBarCont
                props={{
                  variant: 'warning',
                  message: `${currentAccountDetails.contracts_count}
                                     ${t('general:contracts.messages.currently_open', {
                                       count: currentAccountDetails.contracts_count,
                                     })}`,
                  linkto: `/orders/account/${currentAccountDetails.id}`,
                }}
              />
            )}
            {currentAccountDetails.assets_count !== 0 && (
              <ElectroMessageBarCont
                props={{
                  variant: 'warning',
                  message: t('general:assets.owned_assets.assigned'),
                  linkto: `/assets/account/${currentAccountDetails.id}`,
                }}
              />
            )}
            {currentAccountDetails.projects_count !== 0 && (
              <ElectroMessageBarCont
                props={{
                  variant: 'warning',
                  message: `${currentAccountDetails.projects_count}
                                     ${t('general:projects.messages.still_active', {
                                       count: currentAccountDetails.projects_count,
                                     })}`,
                  linkto: formulateUri(`projects/`, {
                    page: 1,
                    filters: [
                      {
                        key: 'account',
                        values: [currentAccountDetails.id],
                      },
                    ],
                  }),
                }}
              />
            )}
          </ActionDrawerBlock>
          <ActionDrawerBlock
            divider={false}
            gutters={true}
            heading={t('general:trading_accounts.reasons.why_archive')}
          >
            <ElectroSelectWithOther
              field={form.$('archiveAccountForm.reason')}
              otherHeading={`${t('general:reasons.provide_reason')} *`}
            />
          </ActionDrawerBlock>
        </div>
        <ActionDrawerFormButtons form={form} submitTxt={t('general:actions.archive_account')} />
      </React.Fragment>
    );
  }
}
